import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import React, { Fragment, useMemo, memo, } from 'react';
import theme from '../../styles/theme';
import { orientations } from './constants';
const defaultProps = {
    orientation: orientations.horizontal,
};
const IconButtonGroup = ({ children, orientation = defaultProps.orientation, }) => {
    const containerStyles = useMemo(() => (css `
        display: flex;
        align-items: flex-start;
        flex-direction: ${orientation === orientations.vertical ? 'column' : 'row'};
        row-gap: ${theme.spacing.x3};
        column-gap: ${theme.spacing.x3};
      `), [
        orientation,
    ]);
    return (_jsx("div", Object.assign({ css: containerStyles, "data-test-ref": "IconButtonGroup-wrapper" }, { children: React.Children.map(children, (child) => (_jsx(Fragment, { children: child }))) })));
};
const MemoizedIconButtonGroup = memo(IconButtonGroup);
export { MemoizedIconButtonGroup as IconButtonGroup };
// MC-1068 Temporary hack for Storybook.
export default IconButtonGroup;
